import {CommissionModelService} from './service/api/commission-model/commission-model.service';
import {CommissionRuleService} from './service/api/commission-rule/commission-rule.service';
import {
    CommissionDecisionSnapshotService
} from './service/api/commission-decision-snapshot/commission-decision-snapshot.service';
import {CommissionExpectationService} from './service/api/commission-expectation/commission-expectation.service';
import {
    ENTITY_SERVICE_REGISTRY,
    EntityServiceEntry
} from 'features/core/shared/dto/dto-service/entity-service-registry';
import {
    CnCommissionRuleObjectComponent
} from './component/protected-components/object-base/cn-commission-rule-object/cn-commission-rule-object.component';
import {
    CnCommissionModelObjectComponent
} from './component/protected-components/object-base/cn-commission-model-object/cn-commission-model-object.component';
import {
    CnCommissionStatementObjectComponent
} from './component/object-components/cn-commission-statement-object/cn-commission-statement-object.component';

/**
* Entity-service registry for the cn (Commission iNcome) module.
*
* Entries with only a route use route-only registration — the framework resolves
* a generic MvsCrudService for standard CRUD operations automatically.
*
* Entries with a service reference have custom logic (getObjectIcon,
* getObjectLabels, or future getObjectComponent via objectComponent[]).
*/
export const CN_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            // Core configuration entities
            // CommissionModel is a Complex Configuration Entity -> resolves to its ObjectComponent (CONFIG-015).
            ['cn.CommissionModel', {
                route: '/cn/commissionModels',
                service: CommissionModelService,
                objectComponent: [{component: CnCommissionModelObjectComponent}]
            }],
            ['cn.CommissionModelAssignment', {route: '/cn/commissionModelAssignments'}],

            // Rule hierarchy
            // CommissionRule is a Complex Configuration Entity -> resolves to its ObjectComponent (CONFIG-015).
            ['cn.CommissionRule', {
                route: '/cn/commissionRules',
                service: CommissionRuleService,
                objectComponent: [{component: CnCommissionRuleObjectComponent}]
            }],
            ['cn.CommissionRuleTier', {route: '/cn/commissionRuleTiers'}],
            ['cn.CommissionCondition', {route: '/cn/commissionConditions'}],

            // Catalog entities
            ['cn.CommissionCalculationBase', {route: '/cn/commissionCalculationBases'}],
            ['cn.CommissionCap', {route: '/cn/commissionCaps'}],
            ['cn.CommissionPartner', {route: '/cn/commissionPartners'}],

            // Liability and buffer templates (cn-internal, not cf)
            ['cn.CommissionLiabilityTemplate', {route: '/cn/commissionLiabilityTemplates'}],
            ['cn.CommissionCancellationBuffer', {route: '/cn/commissionCancellationBuffers'}],

            // Hook registry
            ['cn.CommissionLogicHook', {route: '/cn/commissionLogicHooks'}],

            // Simulation / async run tracking
            ['cn.CommissionSimulationRun', {route: '/cn/commissionSimulationRuns'}],
            ['cn.CommissionDecisionSnapshot', {
                route: '/cn/commissionDecisionSnapshots',
                service: CommissionDecisionSnapshotService
            }],

            // Expectation and trace
            ['cn.CommissionExpectation', {route: '/cn/commissionExpectations', service: CommissionExpectationService}],
            ['cn.CommissionExpectationStep', {route: '/cn/commissionExpectationSteps'}],

            // Statement and reconciliation (P3)
            // CommissionStatement resolves to its detail ObjectComponent (Übersicht / Buchungen /
            // Zeilen / Dokument) so it can be opened by id (click-to-object-page chain, CONFIG-015).
            ['cn.CommissionStatement', {
                route: '/cn/commissionStatements',
                objectComponent: [{component: CnCommissionStatementObjectComponent}]
            }],
            ['cn.CommissionStatementLine', {route: '/cn/commissionStatementLines'}],
            ['cn.CommissionReconciliation', {route: '/cn/commissionReconciliations'}],
            ['cn.CommissionReconciliationComponent', {route: '/cn/commissionReconciliationComponents'}],
            ['cn.CommissionToleranceProfile', {route: '/cn/commissionToleranceProfiles'}],

            // Activity / acknowledgement (P3)
            ['cn.CommissionActivity', {route: '/cn/commissionActivities'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
